import { useFinanceiroObrasToolbar } from "./use-financeiro-obras-toolbar";
import { FinanceiroObrasToolbarView } from "./view-financeiro-obras-toolbar";
import type { FinanceiroObrasToolbarProps } from "./types-financeiro-obras-toolbar";

export function FinanceiroObrasToolbar(props: FinanceiroObrasToolbarProps) {
  const vm = useFinanceiroObrasToolbar(props);
  return <FinanceiroObrasToolbarView {...vm} />;
}

export type * from "./types-financeiro-obras-toolbar";
